import React, { FC, ReactElement, useMemo } from 'react';
import { ConnectorStageHeaderContainer } from './styles';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { ConnectorStageHeaderType } from './model';
import { ConnectorStages } from 'src/products/connector/constants';

const ConnectorStageHeader: FC<ConnectorStageHeaderType> = ({
  stage,
}): ReactElement | null => {
  const canAddConnector = useFeatureFlag('ConnectorsCreateConnector');

  const properties = useMemo(() => {
    if (stage === ConnectorStages.DEV) {
      return {
        message: 'You are currently in ‘DEV’ stage for this connector.',
        backgroundColor: '#FF6294BF',
      };
    }

    if (stage === ConnectorStages.QC) {
      return {
        message: 'You are currently in ‘QC’ stage for this connector.',
        backgroundColor: '#9F4182BF',
      };
    }

    return undefined;
  }, [stage]);

  if (!properties || !canAddConnector) {
    return null;
  }

  const { message, backgroundColor } = properties;

  return (
    <ConnectorStageHeaderContainer backgroundColor={backgroundColor}>
      {message}
    </ConnectorStageHeaderContainer>
  );
};

export default ConnectorStageHeader;
